import React from 'react';
import { SortIcon } from '../../../assets/Icon';
import { ColumnConfig, SortDirection } from './types';

interface TableHeaderProps {
  columns: ColumnConfig[];
  sortColumn: string | null;
  sortDirection: SortDirection;
  onSort: (key: string) => void;
  tableTheadClassName?: string;
  thClassName?: string;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  columns,
  sortColumn,
  sortDirection,
  onSort,
  tableTheadClassName,
  thClassName,
}) => {
  const renderSortIcon = (column: ColumnConfig) => {
    if (!column.sortable) return null;

    return (
      <SortIcon
        size={20}
        dir={sortColumn === column.key ? sortDirection : null}
        color={sortColumn === column.key ? '#000' : '#999999'}
      />
    );
  };

  return (
    <thead className={`bg-light ${tableTheadClassName}`}>
      <tr style={{ display: 'table-row' }}>
        {columns.map(column => (
          <th
            key={column.key}
            style={{
              width: column.width,
              minWidth: column.width,
              cursor: column.sortable ? 'pointer' : 'default',
              display: 'table-cell',
              whiteSpace: 'nowrap',
            }}
            onClick={() => column.sortable && onSort(column.key)}
            className={`px-4 py-3 ${thClassName}`}
          >
            <div
              className="d-flex align-items-center gap-2"
              style={{
                whiteSpace: 'nowrap',
                width: '100%',
              }}
            >
              <span>{column.title}</span>
              <span style={{ flexShrink: 0 }}>{renderSortIcon(column)}</span>
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
